import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CommonLayout from '../../../layouts/CommonLayout';
import { changePassword } from '../../../../api/MemberApi';
import { AlertModal } from '../../../layouts/AlertModal';

const PasswordChangePage = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        currentPassword: '',
        newPassword: '',
        confirmPassword: ''
    });

    // 모달 상태 관리
    const [alertState, setAlertState] = useState({ isVisible: false, message: '', callback: null });

    const getErrorMessage = (error) => {
        if (error.response && error.response.data && error.response.data.message) {
            return error.response.data.message;
        }
        return '현재 비밀번호가 일치하지 않습니다.';
    };

    const validateForm = () => {
        if (!formData.currentPassword) {
            setAlertState({ isVisible: true, message: '현재 비밀번호를 입력해주세요.' });
            return false;
        }
        if (!formData.newPassword) {
            setAlertState({ isVisible: true, message: '새 비밀번호를 입력해주세요.' });
            return false;
        }
        if (formData.newPassword.length < 6) {
            setAlertState({ isVisible: true, message: '비밀번호는 6자리 이상이어야 합니다.' });
            return false;
        }
        if (formData.newPassword !== formData.confirmPassword) {
            setAlertState({ isVisible: true, message: '새 비밀번호가 일치하지 않습니다.' });
            return false;
        }
        if (formData.currentPassword === formData.newPassword) {
            setAlertState({ isVisible: true, message: '새 비밀번호는 현재 비밀번호와 달라야 합니다.' });
            return false;
        }
        return true;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;

        try {
            await changePassword(formData.currentPassword, formData.newPassword);
            setAlertState({
                isVisible: true,
                message: '비밀번호가 성공적으로 변경되었습니다.',
                callback: () => navigate('/app/mypage', { replace: true })
            });
        } catch (error) {
            setAlertState({ isVisible: true, message: getErrorMessage(error) });
        }
    };

    return (
        <CommonLayout title="비밀번호 변경">
            <AlertModal
                isVisible={alertState.isVisible}
                message={alertState.message}
                callback={alertState.callback}
                onClose={() => setAlertState({ isVisible: false, message: '', callback: null })}
            />
            <div className="space-y-4 p-4">
                <div className="text-sm font-semibold">현재 비밀번호</div>
                <div>
                    <input
                        type="password"
                        value={formData.currentPassword}
                        onChange={(e) => setFormData(prev => ({...prev, currentPassword: e.target.value}))}
                        placeholder="현재 비밀번호를 입력해주세요"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                    />
                </div>

                <div className="text-sm font-semibold">새 비밀번호</div>
                <div>
                    <input
                        type="password"
                        value={formData.newPassword}
                        onChange={(e) => setFormData(prev => ({...prev, newPassword: e.target.value}))}
                        placeholder="새 비밀번호를 입력해주세요 (6자리 이상, 16자 이하)"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                        minLength="6"
                        maxLength="16"
                    />
                </div>

                <div className="text-sm font-semibold">새 비밀번호 확인</div>
                <div>
                    <input
                        type="password"
                        value={formData.confirmPassword}
                        onChange={(e) => setFormData(prev => ({...prev, confirmPassword: e.target.value}))}
                        placeholder="새 비밀번호를 다시 입력해주세요"
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg"
                        minLength="6"
                        maxLength="16"
                    />
                </div>

                {formData.newPassword && formData.confirmPassword && formData.newPassword !== formData.confirmPassword && (
                    <div className="text-sm text-red-500">새 비밀번호가 일치하지 않습니다</div>
                )}

                <button
                    onClick={handleSubmit}
                    className="w-full py-3 bg-amber-500 text-white rounded-lg"
                >
                    변경하기
                </button>
            </div>
        </CommonLayout>
    );
};

export default PasswordChangePage;
